import { Link } from "react-router-dom";
import { StoryImage } from "./Media";
import { CategoryTag } from "./Content";
import { fmtDate } from "@/lib/format";

export const StoryRow = ({ story }) => (
  <article className="group relative grid gap-5 py-8 sm:grid-cols-12 sm:gap-8" data-testid={`story-row-${story.slug}`}>
    <StoryImage src={story.image} alt={story.imageAlt} className="self-start sm:col-span-4" testId={`story-row-image-${story.slug}`} imgClassName="transition-transform duration-500 group-hover:scale-[1.03]" />
    <div className="sm:col-span-8">
      <div className="flex flex-wrap items-center gap-3">
        <CategoryTag>{story.category}</CategoryTag>
        <span className="text-ink-muted" aria-hidden="true">·</span>
        <time dateTime={story.date} className="text-sm text-ink-muted">{fmtDate(story.date)}</time>
      </div>
      <h3 className="mt-3 text-xl font-extrabold leading-snug tracking-tight text-ink sm:text-2xl">
        <Link to={`/research/${story.slug}`} className="card-link group-hover:text-brand" data-testid={`story-link-${story.slug}`}>
          {story.title}
        </Link>
      </h3>
      <p className="mt-3 max-w-2xl leading-relaxed text-ink-muted">{story.summary}</p>
    </div>
  </article>
);

export const StoryCard = ({ story, large = false }) => (
  <article className="group relative" data-testid={`story-card-${story.slug}`}>
    <StoryImage src={story.image} alt={story.imageAlt} testId={`story-card-image-${story.slug}`} imgClassName="transition-transform duration-500 group-hover:scale-[1.03]" />
    <div className="mt-5 flex flex-wrap items-center gap-3">
      <CategoryTag>{story.category}</CategoryTag>
      <time dateTime={story.date} className="text-sm text-ink-muted">{fmtDate(story.date)}</time>
    </div>
    <h3 className={`mt-2 font-extrabold leading-snug tracking-tight text-ink ${large ? "text-2xl sm:text-3xl" : "text-lg"}`}>
      <Link to={`/research/${story.slug}`} className="card-link group-hover:text-brand" data-testid={`story-card-link-${story.slug}`}>
        {story.title}
      </Link>
    </h3>
    {large && <p className="mt-3 leading-relaxed text-ink-muted">{story.summary}</p>}
    {large && <span className="mt-5 inline-flex items-center gap-2 text-sm font-bold text-brand" aria-hidden="true">Read story <span className="transition-transform duration-200 group-hover:translate-x-1">→</span></span>}
  </article>
);
